import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=f2881ff8&scoped=true"
import script from "./BaseAlert.vue?vue&type=script&lang=js"
export * from "./BaseAlert.vue?vue&type=script&lang=js"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=f2881ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2881ff8",
  null
  
)

export default component.exports